import React from 'react';
import { Product } from '../../types';
import { useRelatedProducts } from '../../viewmodels/useRelatedProducts';
import ProductCard from '../product/ProductCard';

interface RelatedProductsProps {
  product: Product;
  title: string;
  count: number;
}

const RelatedProducts: React.FC<RelatedProductsProps> = ({ product, title, count }) => {
  const { relatedProducts, isLoading } = useRelatedProducts({ product, count });

  if (isLoading) {
    return (
      <div className="mt-16 pt-12 border-t border-border-light" data-testid="related-products">
        <h2 className="text-2xl font-serif text-text-primary mb-8 text-center">
          {title}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="aspect-[3/4] bg-bg-secondary rounded" />
              <div className="mt-3 h-4 bg-bg-secondary rounded w-3/4" />
              <div className="mt-2 h-4 bg-bg-secondary rounded w-1/2" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (relatedProducts.length === 0) {
    return null;
  }

  return (
    <div className="mt-16 pt-12 border-t border-border-light" data-testid="related-products">
      <h2 className="text-2xl font-serif text-text-primary mb-8 text-center">
        {title}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {relatedProducts.map((relatedProduct) => (
          <ProductCard key={relatedProduct.id} product={relatedProduct} />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
